export enum TaskType {
  Enabled = 0,
  Disabled = 1,
}
